import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-221">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-222">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-223">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-224">
          {isOpen ? <XIcon size={24} data-id="element-225" /> : <PlusIcon size={24} data-id="element-226" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-227">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-228">
          {answer}
        </p>
      </div>
    </div>;
}
export function BBLFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'Who Is A Good Candidate For These Treatments?',
    answer: 'BBL treatments are suitable for individuals with various skin types and cosmetic concerns. Generally, individuals with fair to medium skin tones tend to respond well to photofacial treatments. Darker skin tones may require a modified approach to avoid potential complications like hyperpigmentation. If you have active skin infections or are pregnant, photofacial treatments may not be suitable for you. During your consultation at Be CLINICAL, we will evaluate your skin type, assess your concerns and goals, and discuss your medical history.'
  }, {
    question: 'Should I Get A Photofacial Or Microneedling?',
    answer: "Both photofacials and microneedling treatments offer unique benefits for improving the skin's appearance. Photofacials primarily target pigmentation and redness, while microneedling focuses on stimulating collagen production and improving texture. At Be CLINICAL, we offer both treatments. During your consultation, we can evaluate your skin and suggest the best option for you."
  }, {
    question: 'What Areas Can Be Treated With Forever Clear?',
    answer: 'You can treat areas of concern on your face, neck, chest and back with BBL treatments. This means acne breakouts that are harder to treat with topical products can be easily treated with BBL. Visible redness and inflammation begins to subside after just one treatment!'
  }, {
    question: 'How Many Sessions Are Needed To See Results?',
    answer: "Each individual's needs vary, but typically, a series of 3-4 treatments is recommended to achieve significant improvement in skin concerns. Generally, BBL sessions are spaced a few weeks apart. Dr. Fiona recommends getting them every few months for a lifetime of gorgeous skin!"
  }, {
    question: 'Is There Any Downtime After A Photofacial Treatment?',
    answer: 'Most individuals can resume their normal activities immediately after a photofacial treatment, as there is typically minimal to no downtime. Some individuals may experience mild redness or slight swelling, which usually subsides within a few hours to a day.'
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-229">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-230">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-231">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-232">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-233"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-234">
          <div className="space-y-2" data-id="element-235">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-236" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}